// Currency selection shared across matching screens (dashboard + active payouts).
// The stored key is intentionally shared so the choice follows the user between
// the matching dashboard and the active-payouts balance block.
export const CURRENCY_STORAGE_KEY = 'matching-dashboard-currency'
export const DEFAULT_CURRENCY = 'RUB'
